import './Footer.css';

export default function Footer() {
  return (
    <footer className="footer">
      <small className="footer__text">
        © {new Date().getFullYear()} Notflix — All rights reserved.
      </small>
    </footer>
  )
}
